<template>
  <div>
  <b-card>
    <div>
      <b-row class="temp_mapping">
        <b-col md="8">
          <h4>{{ $t('Mappings') }}</h4>
        </b-col>
        <b-col md="4">
          <div class="float-right add-field-btn">
            <b-button type="submit" size="sm" variant="secondary" class="mt-0" v-b-modal.externalService >
            <i class="fa fa-plus"> </i> <span> {{ $t('Add new mapping') }} </span>
            </b-button>
            <b-button type="submit" size="sm" variant="secondary" class="mt-0" v-b-modal.importMappings >
            <i class="fa fa-upload"> </i> <span> {{ $t('CONFIGURED.IMPORT_MAPPINGS') }} </span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-card>
  <b-card>
    <div>
      <b-row class="temp_mapping">
        <b-col md="6">
          <b-row>
            <b-col md="5">
              {{ $t('ACCOUNT.CURRENT_SALESFORCE_ORG') }}
            </b-col>
            <b-col md="7">
              {{ extServiceData.external_service_title }}
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row>
            <b-col md="2">
              {{ $t('ACCOUNT.CURRENT_SALESFORCE_URL') }}
            </b-col>
            <b-col md="7">
              {{ extServiceData.external_service_url }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-card>
  <b-row>
    <b-col cols="6" v-for="map in this.externalServiceMaps" :key="map.id">
      <b-card>
        <b-card border-variant="info" align="left">
          <div slot="header">
            <b-row>
              <b-col md="8">
                <h5>{{ map.name }}</h5>
              </b-col>
              <b-col md="4">
                <div class="float-right add-field-btn">
                  <b-button type="submit" size="sm" variant="primary" class="mt-0" @click="editExternalServiceMap(map.template_doc_id)"><i class="fa fa-edit"></i></b-button>
                  <b-button type="submit" size="sm" variant="danger" class="mt-0" @click="showDeleteModal(map.template_doc_id)"><i class="fa fa-trash"></i></b-button>
                </div>
              </b-col>
            </b-row>
          </div>
          <p class="card-text">
            <b-row >
              <b-col cols="4">Integration Type:</b-col>
              <b-col cols="8 text-left">{{map.integration_type}}</b-col>
            </b-row>
            <b-row >
              <b-col cols="4">Connection Type:</b-col>
              <b-col cols="8 text-left">{{map.connection_type}}</b-col>
            </b-row>
            <b-row >
              <b-col cols="4">External Url:</b-col>
              <b-col cols="8 text-left">{{map.external_service_url}}</b-col>
            </b-row>
            <b-row >
              <b-col cols="4">Template:</b-col>
              <b-col cols="8 text-left">{{map.template}}</b-col>
            </b-row>
            <b-row v-if="!demoMode">
              <b-col cols="4">Username:</b-col>
              <b-col cols="8 text-left">{{map.username}}</b-col>
            </b-row>
            <b-row v-if="!demoMode">
              <b-col cols="4">Password:</b-col>
              <b-col cols="8 text-left">{{map.password}}</b-col>
            </b-row>
            <b-row v-if="!demoMode">
              <b-col cols="4">Description:</b-col>
              <b-col cols="8 text-left">{{map.description}}</b-col>
            </b-row>
          </p>
        </b-card>
      </b-card>
    </b-col>
  </b-row>
    <!-- External Service Modal -->
    <b-modal id="externalService" size="lg" class="external-service-modal" :title="extServiceData.created ? 'New Mapping' : 'Edit Mapping'" hide-footer header-bg-variant="light" ref="externalServiceModal" @hidden="onHidingExtSerModal">
      <b-row v-if="extServiceData.integration_type">
        <b-col cols="12">
          <b-row>
            <b-col cols="2">Connection Type:</b-col>
            <b-col cols="4 text-left">
              <b-form-select :plain="true" v-model="extServiceData.connection_type" :options="connectionTypes" @change="handleSelectedConnectionType"></b-form-select>
            </b-col>
            <b-col cols="6" v-if="extServiceData.connection_type === 'Salesforce'">
              <b-row>
                <b-col cols="4">External Url:</b-col>
                <b-col cols="8 text-left">
                  <b-form-input type="text" v-model="extServiceData.external_service_url" placeholder="external url" ref="fieldKey" disabled></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Name:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text" v-model="extServiceData.name" placeholder="external url" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Username:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text"  v-model="extServiceData.username" placeholder="username" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Password:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text"  v-model="extServiceData.password" placeholder="password" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Description:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text"  v-model="extServiceData.description" placeholder="description" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row></b-row>
          <b-row v-if="!demoMode" >
            <b-col cols="3">Fields:</b-col>
            <b-col cols="9 text-left">
              <b-form-select :plain="true" :options="extConnection.extFields"></b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="extServiceData.connection_type === 'Salesforce'">
        <b-col cols="6">
          <b-row>
            <b-col cols="4">Integration type:</b-col>
            <b-col cols="8 text-left">
              <b-form-select :plain="true" v-model="extServiceData.integration_type" :options="integrationTypes" @change="handleSelectedIntegrationType"></b-form-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6">
          <b-row>
            <b-col cols="4">Process Type:</b-col>
            <b-col cols="8 text-left">
              <b-form-select :plain="true" v-model="extServiceData.process_type" :options="processTypes" @change="handleSelectedProcessType"></b-form-select>
              <div style="color:red" v-if="extServiceData.process_type == null">Please select Process Type.</div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6" v-if="showTemplateRow">
          <b-row>
            <b-col cols="4">Select Template:</b-col>
            <b-col cols="8 text-left">
              <b-form-select :plain="true" v-model="templateDoc.selectedTemplateDocId" :options="availableTemplateDocs" @change="handleSelectedTemplate"></b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-else>
      </b-row>
      <div v-if="extServiceData.process_type != null">
        <b-row>
        </b-row>
        <b-row v-if="showVersionsRow">
          <b-col cols="6">
            <b-row>
              <b-col cols="4">Select Page:</b-col>
              <b-col cols="8 text-left">
                <b-form-select cols="8" :plain="true" :options="availableTemplates" v-model="selectedTemplate" @change="fetchTemplateVersion"></b-form-select>
                <div style="color:red" v-if="selectedTemplate == null">Please select a page.</div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="4">Select Version:</b-col>
              <b-col cols="8 text-left">
                <b-form-select :plain="true" :options="availableTemplateVersions" v-model="selectedTemplateVersion" @change="resetObjectRow"></b-form-select>
                <div style="color:red" v-if="selectedTemplateVersion == null">Please select a version.</div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4"/>
          <b-col cols="4 text-left">
            <b-btn size="sm" class="float-right create-button" @click="createMapping" variant="secondary mr-1"  :disabled="!(extServiceData.process_type)">Create/Fetch</b-btn>
          </b-col>
        </b-row>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Mappings" active style="background-color: white">
              <b-row v-if="showObjectRow">
                <b-col cols="4">
                  <b-row>
                    <b-col cols="4">Select Object:</b-col>
                    <b-col cols="8 text-left">
                      <model-select class="modelSelect" :plain="true" :options="extConnection.extObjects" v-model="extConnection.selectedObj" placeholder="Select External Object"></model-select>
                      <div style="color:red" v-if="!extConnection.selectedObj">Please select an object.</div>
                      <span>{{ this.extConnection.selectedObj }}</span>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row v-if="showEFM">
                <b-col cols="4">
                  <b-card border-variant="info"
                        header="Map Fields"
                        align="center" >
                    <p class="card-text">
                      <b-row>
                        <b-col cols="11 text-left">
                          <label>External Fields</label>
                          <model-select class="modelSelect" :plain="true" :options="extConnection.extFields"  v-model="externalServiceMap.selectedExtField" placeholder="Select External Field"></model-select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="11 text-left">
                          <label>Mapping Type</label>
                          <b-form-select :plain="true" :options="mappingTypeOptions"  v-model="mappingType"></b-form-select>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="11 text-left" v-if="mappingType === 'TEMPLATE_FIELD'">
                          <label>Template Fields</label>
                          <model-select class="modelSelect" :plain="true" :options="templateDoc.tmpFields" v-model="externalServiceMap.selectedTmpField"></model-select>
                        </b-col>
                      </b-row>
                      <b-row>
                         <b-col cols="11 text-left" v-if="mappingType === 'DEFAULT'">
                          <label>Default Value</label>
                          <b-form-input v-model="defaultValue" placeholder="Enter Default Value"></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="11 text-left">
                          <label>Section</label>
                          <b-form-select :plain="true" :options="sectionsList" v-model="selectedSection"></b-form-select>
                        </b-col>
                        <b-col cols="2 text-left" v-if="mappingType">
                          <label>Action</label>
                          <b-btn size="sm" style="padding: 1px 10px; border-radius: 10px" @click="addFieldMapping" variant="secondary" :disabled="selectedSection.length < 1" ><i class="fa fa-plus"> </i></b-btn>
                        </b-col>
                      </b-row>
                      <b-row>
                        <p id="displayReqFields" style="color:red; padding: 1px 15px;" v-if="this.extConnection.reqFields.length">
                        Note: In External fields combo box, {{this.extConnection.reqFields.length}}{{$t('COMMON.REQ_FIELD_WARNING')}}</p>
                        <p id="displayReqFields" v-if="!this.extConnection.reqFields.length">&nbsp;</p>
                        <b-popover target="displayReqFields" triggers="hover" placement="left">
                          {{this.extConnection.reqStr}}
                        </b-popover>
                      </b-row>
                    </p>
                  </b-card>
                </b-col>
                <b-col cols="8">
                  <b-card border-variant="info"
                        align="left" >
                    <div slot="header">
                      <b-row style="margin: 0px">
                        <b-col md="10">
                          <h6 style="margin: 1px 0px 0px 0px">Mapped Fields</h6>
                        </b-col>
                        <b-col md="2">
                          <i class="fa fa-download download-efm fa-lg" @click="downloadEsmappings" v-b-tooltip.hover title='Download ExternalServiceMappings'></i>
                        </b-col>
                        <b-col md="2" v-if="shouldShowDownload">
                          <div class="float-right">
                            <i class="fa fa-download download-efm" @click="downloadESM" v-b-tooltip.hover title='Download Mappings' ></i>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                    <p class="card-text">
                      <b-row v-for="(section,index) in this.sectionsList ? this.sectionsList.concat([null]) : []" :key="index">
                        <b-col cols=12>
                           <strong v-if="externalServiceMap.externalFieldMappings.filter(mapping=> mapping.section === section).length > 0">{{section === null ? ' NA ': section}} :</strong>
                          <b-row v-for="map in externalServiceMap.externalFieldMappings.filter(mapping=> mapping.section === section)" :key="map.id">
                            <b-col sm="5">
                              {{ map.ext_field_api }} &nbsp; ( {{map.ext_field_object}} )
                              &nbsp;
                            </b-col>
                            <b-col sm="5">
                              <i class="fa fa-link"/> &nbsp;
                              {{ map.tmp_key && map.tmp_key != null && map.tmp_key !== 'null' ? map.tmp_key : ' (DEFAULT) ' + map.default_value }}
                            </b-col>
                             <b-col sm="2">
                              <i class="fa fa-trash" style="color: red; cursor: pointer;" @click="deleteExternalFieldMap(map.id, map.ext_field_api)" />
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </p>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Sections" style="background-color: white">
            <b-card>
              <b-card class="multi-card">
                <div slot="header">
                  <b-row>
                    <b-col md="4">
                      <h5>{{ $t('CONFIGURED.SECTION_ORDER') }}</h5>
                    </b-col>
                    <b-col md="8">
                        <span>
                          <b-form-input style="max-width:50%; display:inline" size='md' v-model="sectionName" :placeholder="$t('CONFIGURED.ENTER_SECTION_NAME')"></b-form-input>
                        </span>
                        <span>
                          <b-button style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; padding:4px 10px 4px 11px" size="sm"
                          variant="secondary" v-on:click="addSectionName()">
                          <i class="fa fa-plus"> </i>
                          </b-button>
                          <b-button style="margin-bottom: 5px;padding-bottom: 0px;border-radius: 6px; padding:4px 10px 4px 11px" size="sm"
                          variant="secondary" v-on:click="updateSectionOrder()">
                          <i class="fa fa-save">{{ $t('COMMON.SAVE') }} </i>
                        </b-button>
                        </span>
                    </b-col>
                  </b-row>
                </div>
                <div class="timeline-div">
                  <ul class="timeline timeline-horizontal">
                  <draggable v-model="sectionsList" :options="{ group:'sections'}"  class="flex-container">
                    <li class="timeline-item" v-for="(section,index) in sectionsList" :key="index">
                      <div class="timeline-badge bg-primary"><strong>{{index + 1}}</strong></div>
                      <div class="timeline-panel role-panel"><p>{{ section }}</p>
                        <p><i class="fa fa-trash" style="color: red; cursor: pointer;" @click="deleteSectionName(section)" /></p>

                      </div>
                    </li>
                    </draggable>
                  </ul>
                </div>
                <em class="italic">{{ $t('CONFIGURED.SECTION_NOTE') }}</em>
              </b-card>
            </b-card>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </b-modal>

    <b-modal id="importMappings" size="lg" class="external-service-modal" title="Import Mappings" hide-footer header-bg-variant="light" ref="externalServiceImportModal" @hidden="onHidingExtSerModal">
      <b-row v-if="extServiceData.integration_type">
        <b-col cols="12">
          <b-row>
            <b-col cols="2">Connection Type:</b-col>
            <b-col cols="4 text-left">
              <b-form-select :plain="true" v-model="extServiceData.connection_type" :options="connectionTypes" @change="handleSelectedConnectionType"></b-form-select>
            </b-col>
            <b-col cols="6" v-if="extServiceData.connection_type === 'Salesforce'">
              <b-row>
                <b-col cols="4">External Url:</b-col>
                <b-col cols="8 text-left">
                  <b-form-input type="text" v-model="extServiceData.external_service_url" placeholder="external url" ref="fieldKey" disabled></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Name:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text" v-model="extServiceData.name" placeholder="external url" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Username:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text"  v-model="extServiceData.username" placeholder="username" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Password:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text"  v-model="extServiceData.password" placeholder="password" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row v-if="!demoMode">
            <b-col cols="4">Description:</b-col>
            <b-col cols="8 text-left">
              <b-form-input type="text"  v-model="extServiceData.description" placeholder="description" ref="fieldKey"></b-form-input>
            </b-col>
          </b-row>
          <b-row></b-row>
          <b-row v-if="!demoMode" >
            <b-col cols="3">Fields:</b-col>
            <b-col cols="9 text-left">
              <b-form-select :plain="true" :options="extConnection.extFields"></b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-if="extServiceData.connection_type === 'Salesforce'">
        <b-col cols="6">
          <b-row>
            <b-col cols="4">Integration type:</b-col>
            <b-col cols="8 text-left">
              <b-form-select :plain="true" v-model="extServiceData.integration_type" :options="integrationTypes" @change="handleSelectedIntegrationType"></b-form-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6">
          <b-row>
            <b-col cols="4">Process Type:</b-col>
            <b-col cols="8 text-left">
              <b-form-select :plain="true" v-model="extServiceData.process_type" :options="processTypes" @change="handleSelectedProcessType"></b-form-select>
              <div style="color:red" v-if="extServiceData.process_type == null">Please select Process Type.</div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="6" v-if="showTemplateRow">
          <b-row>
            <b-col cols="4">Select Template:</b-col>
            <b-col cols="8 text-left">
              <b-form-select :plain="true" v-model="templateDoc.selectedTemplateDocId" :options="availableTemplateDocs" @change="handleSelectedTemplate"></b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row v-else>
      </b-row>
      <div v-if="extServiceData.process_type != null">
        <b-row>
        </b-row>
        <b-row v-if="showVersionsRow">
          <b-col cols="6">
            <b-row>
              <b-col cols="4">Select Page:</b-col>
              <b-col cols="8 text-left">
                <b-form-select cols="8" :plain="true" :options="availableTemplates" v-model="selectedTemplate" @change="fetchTemplateVersion"></b-form-select>
                <div style="color:red" v-if="selectedTemplate == null">Please select a page.</div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="4">Select Version:</b-col>
              <b-col cols="8 text-left">
                <b-form-select :plain="true" :options="availableTemplateVersions" v-model="selectedTemplateVersion" @change="resetObjectRow"></b-form-select>
                <div style="color:red" v-if="selectedTemplateVersion == null">Please select a version.</div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-col cols="4">Select File:</b-col>
              <b-col cols="8 text-left">
                <input id="fileUpload" type="file" ref="file" v-on:change="handleFileUpload()">
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col cols="3"/>
          <div>
            <b-btn size="sm" variant="secondary" @click="saveImportMappings" :disabled="!isFileSelected"> {{ $t('CONFIGURED.CREATE') }} </b-btn>
            <b-btn size="sm" variant="light" @click="hideImportModal"> {{ $t('COMMON.CLOSE') }} </b-btn>
          </div>
        </b-row>
      </div>
    </b-modal>

    <b-modal centered
    id="deleteModal"
    ref="deleteModal"
    :title="$t('COMMON.DELETE_CONFIRM')"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('COMMON.DELETE')"
    :cancel-title="$t('COMMON.CANCEL')"
    ok-variant="secondary"
    cancel-variant="light"
    @cancel="cancel"
    @keydown.native.enter="deleteExternalServiceMap"
    @ok="deleteExternalServiceMap" >
    <div class="delete-warning">
      <p>{{$t('COMMON.DEL_SERVICEMAPPING')}}</p>
    </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import draggable from 'vuedraggable'
import { ModelSelect } from 'vue-search-select'

export default {
  data () {
    return {
      demoMode: true,
      externalServiceMaps: [],
      availableTemplateDocs: [],
      availableTemplates: [],
      availableTemplateVersions: [],
      selectedTemplate: null,
      selectedTemplateVersion: null,
      text: '',
      file: '',
      isFileSelected: false,
      processTypes: [
        { text: 'Templates', value: 'Templates' },
        { text: 'Insurance Card', value: '-2' },
        { text: 'Driving License', value: '-5' }
      ],
      integrationTypes: [
        { text: 'Default', value: 'Default' },
        { text: 'MuleSoft', value: 'MuleSoft' },
        { text: 'Informatica', value: 'Informatica' },
        { text: 'Dell Boomi', value: 'Dell Boomi' },
        { text: 'Custom', value: 'Custom' }
      ],
      connectionTypes: [
        { text: 'Select Service', value: null, disabled: true },
        { text: 'Salesforce', value: 'Salesforce' },
        { text: 'EHR', value: 'EHR' },
        { text: 'LIMS', value: 'LIMS' },
        { text: 'Other', value: 'Other' }
      ],
      showObjectRow: false,
      showTemplateRow: false,
      showVersionsRow: false,
      showEFM: false,
      template_doc_id: null,
      extServiceData: {
        integration_type: 'Default',
        connection_type: null,
        process_type: null,
        name: '',
        description: '',
        external_service_url: '',
        external_service_title: '',
        username: '',
        password: '',
        created: true
      },
      templateDoc: {
        selectedTemplateDocId: null,
        tmpFields: []
      },
      extConnection: {
        extObjects: [],
        selectedObj: null,
        extFields: [],
        reqFields: [],
        allReqFields: [],
        reqStr: ''
      },
      externalServiceMap: {
        externalServiceMapId: '',
        externalFieldMappings: [],
        selectedTmpField: '',
        selectedExtField: ''
      },
      mappingType: null,
      mappingTypeOptions: [],
      defaultValue: '',
      sectionsList: [],
      sectionName: '',
      selectedSection: ''
    }
  },
  components: {
    draggable,
    ModelSelect
  },
  computed: {
    ...mapGetters(['idToken', 'selectedRolesData', 'isAdminRole', 'accountId']),
    shouldShowDownload: function () {
      let integrationType = this.extServiceData.integration_type
      let efm = this.externalServiceMap.externalFieldMappings
      return ((integrationType === 'MuleSoft') && (efm.length > 0))
    }
  },
  watch: {
    'extConnection.selectedObj': function () {
      this.fetchObjectFields()
    },
    'mappingType': function () {
      this.defaultValue = ''
    },
    'extConnection.reqFields': function () {
      this.extConnection.reqStr = ''
      for (let [index, req] of this.extConnection.reqFields.entries()) {
        this.extConnection.reqStr += req.text
        if (index !== this.extConnection.reqFields.length - 1) {
          this.extConnection.reqStr += ', '
        }
      }
    },
    'extConnection.extFields': function () {
      this.defaultValue = ''
    }
  },
  created () {
    let vm = this
    vm.mappingTypeOptions = [{ text: 'Select Mapping Type', value: null, disabled: true },
      { text: 'Default value', value: 'DEFAULT' },
      { text: 'Template Fields', value: 'TEMPLATE_FIELD' }]
    Vue.axios.get('/settings/external_service_maps', { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        vm.externalServiceMaps = res.data.external_service_maps
        vm.availableTemplateDocs = [{ text: 'Select Template', value: null, disabled: true }].concat(res.data.available_templates)
      })
      .catch(error => {
        if (error.status === 401) {
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
    Vue.axios.get('/settings/external_service_maps/fetch_external_url', { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        vm.extServiceData.external_service_url = res.data.external_url
        vm.extServiceData.external_service_title = res.data.external_title
      })
      .catch(error => {
        if (error.status === 401) {
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  methods: {
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      this.isFileSelected = true
      const reader = new window.FileReader()
      reader.onload = evt => {
        try {
          this.text = JSON.parse(evt.target.result)
        } catch (error) {
          this.isFileSelected = false
          Vue.toasted.show(this.$t('COMMON.FILE_ERROR'), { icon: 'chain-broken', type: 'error' })
          return
        }
        let payload = {
          integration_type: this.extServiceData.integration_type,
          connection_type: this.extServiceData.connection_type,
          name: this.extServiceData.name,
          template_doc_id: this.templateDoc.selectedTemplateDocId,
          template_id: this.selectedTemplate,
          revision_id: this.selectedTemplateVersion,
          description: this.extServiceData.description,
          external_service_url: this.extServiceData.external_service_url,
          username: this.extServiceData.username,
          password: this.extServiceData.password,
          mapping_data: this.text,
          account_id: this.accountId
        }
        this.mappingPayload = payload
        console.log(this.mappingPayload)
      }
      reader.readAsText(this.file)
    },
    hideImportModal () {
      this.$refs.externalServiceImportModal.hide()
    },
    saveImportMappings () {
      Vue.axios.post('/settings/external_service_maps/save_import_mappings', this.mappingPayload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
            this.$refs.externalServiceImportModal.hide()
            if (!res.data.error) {
              router.go()
            }
          } else {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadEsmappings () {
      let id = this.externalServiceMap.externalServiceMapId
      Vue.axios.get('/settings/external_service_maps/' + id + '/download_esmappings', { headers: {
        Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.mappingData = res
          const data = JSON.stringify(this.mappingData.data.mappings)
          const templateName = JSON.stringify(this.mappingData.data.template_name).replace(/\s+/g, '_')
          const filename = templateName + '_external_service_mappings' + '_version' + this.selectedTemplateVersion + '.txt'
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data))
          element.setAttribute('Download', filename)
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    showDeleteModal (templateDocId) {
      this.template_doc_id = templateDocId
      this.$refs['deleteModal'].show()
    },
    cancel () {
      this.$refs['deleteModal'].hide()
    },
    addSectionName () {
      this.sectionsList.push(this.sectionName)
      this.sectionName = ''
    },
    deleteSectionName (name) {
      this.sectionsList = this.sectionsList.filter(section => section !== name)
      this.sectionName = ''
    },
    onHidingExtSerModal () {
      this.resetData()
    },
    updateSectionOrder () {
      var formData = new window.FormData()
      formData.append('template_doc_id', this.templateDoc.selectedTemplateDocId)
      formData.append('section_list', JSON.stringify(this.sectionsList))
      Vue.axios.post('/settings/external_field_maps/update_section_order', formData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          Vue.toasted.show(this.$t('CONFIGURED.SECTION_ORDER_SUCCESS'))
        }, error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    resetData (esmDataOnly = false) {
      if (!esmDataOnly) {
        this.extServiceData = {
          integration_type: 'Default',
          connection_type: null,
          process_type: null,
          name: '',
          description: '',
          external_service_url: this.extServiceData.external_service_url,
          external_service_title: this.extServiceData.external_service_title,
          username: '',
          password: '',
          created: true
        }
        this.templateDoc = {
          selectedTemplateDocId: null,
          tmpFields: []
        }
      }
      this.availableTemplates = []
      this.availableTemplateVersions = []
      this.selectedTemplate = null
      this.selectedTemplateVersion = null
      this.showEFM = false
      this.showObjectRow = false
      this.showVersionsRow = false
      this.extConnection = {
        extObjects: [],
        selectedObj: null,
        extFields: [],
        reqFields: [],
        allReqFields: []
      }
      this.externalServiceMap = {
        externalServiceMapId: '',
        externalFieldMappings: [],
        selectedTmpField: '',
        selectedExtField: ''
      }
    },
    handleSelectedIntegrationType (newValue) {
      if (newValue === 'Default') {
        this.connectionTypes = [
          { text: 'Select Service', value: null },
          { text: 'Salesforce', value: 'Salesforce' },
          { text: 'EHR', value: 'EHR' },
          { text: 'LIMS', value: 'LIMS' },
          { text: 'Other', value: 'Other' }
        ]
        this.extServiceData.connection_type = null
        this.extServiceData.created = true
      } else {
        this.connectionTypes = [{ text: 'Salesforce', value: 'Salesforce' }]
        this.extServiceData.connection_type = 'Salesforce'
        this.extServiceData.created = true
      }
      this.resetData(true)
    },
    handleSelectedTemplate (newValue) {
      this.extServiceData.created = true
      this.resetData(true)
      this.fetchData(newValue)
    },
    handleSelectedConnectionType () {
      this.extServiceData.created = true
      this.resetData(true)
    },
    handleSelectedProcessType (newValue) {
      if (newValue === 'Templates') {
        this.showTemplateRow = true
      } else {
        if (newValue === '-2') {
          this.showTemplateRow = true
          this.showVersionsRow = true
        } else {
          this.selectedTemplate = '-5'
          this.templateDoc.selectedTemplateDocId = '-5'
          this.showTemplateRow = false
          this.showVersionsRow = false
        }
      }
      this.extServiceData.created = true
    },
    fetchData (newValue) {
      let params = new window.FormData()
      params.append('template_doc_id', newValue)
      params.append('external_service_url', this.extServiceData.external_service_url)
      Vue.axios.post('/settings/external_service_maps/fetch_templates', params, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let result = res.data
          this.showVersionsRow = true
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
          this.extConnection.extObjects = [].concat(result.objects)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplateVersion (newValue) {
      this.showObjectRow = false
      this.showEFM = false
      this.selectedTemplateVersion = null
      if (newValue) {
        Vue.axios.get('/settings/external_service_maps/fetch_versions?template_id=' + newValue, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            let result = res.data
            this.availableTemplateVersions = [{text: 'Select Page', value: null, disabled: true}].concat(result.versions)
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    resetObjectRow () {
      this.showObjectRow = false
      this.showEFM = false
    },
    createMapping () {
      this.showObjectRow = false
      this.showEFM = false
      if (this.extServiceData.connection_type === 'Salesforce') {
        let mappingData = new window.FormData()
        mappingData.append('integration_type', this.extServiceData.integration_type)
        mappingData.append('connection_type', this.extServiceData.connection_type)
        mappingData.append('name', this.extServiceData.name)
        mappingData.append('template_doc_id', this.templateDoc.selectedTemplateDocId)
        mappingData.append('template_id', this.selectedTemplate)
        mappingData.append('revision_id', this.templateDoc.selectedTemplateDocId === '-2' ? '1' : this.selectedTemplateVersion)
        mappingData.append('description', this.extServiceData.description)
        mappingData.append('external_service_url', this.extServiceData.external_service_url)
        mappingData.append('username', this.extServiceData.username)
        mappingData.append('password', this.extServiceData.password)
        Vue.axios.post('/settings/external_service_maps', mappingData, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            if (response.data.status === 'SUCCESS') {
              let result = response.data
              this.extServiceData.created = result.external_service_maps.created
              this.externalServiceMap.externalServiceMapId = result.external_service_maps.id
              this.externalServiceMap.externalFieldMappings = result.external_field_mappings
              this.sectionsList = result.sections ? result.sections : []
              this.templateDoc.tmpFields = result.template_fields
              if (this.templateDoc.tmpFields) {
                this.templateDoc.tmpFields.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0))
              }
              this.extConnection.extFields = result.external_fields
              this.extConnection.extObjects = [].concat(result.objects)
              this.extConnection.selectedObj = null
              this.showObjectRow = true
              if (result.external_service_maps.created) {
                let newMaps = this.externalServiceMaps.filter((esm, index) => { return esm.template_doc_id !== this.templateDoc.selectedTemplateDocId }).concat([result.external_service_maps])
                this.externalServiceMaps = newMaps
              }
              Vue.toasted.show(response.data.message)
            } else {
              Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            if (error.response.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      } else {
        Vue.toasted.show(this.$t('COMMON.MSG_INACTIVE'), { icon: 'chain-broken', type: 'error' })
      }
    },
    fetchObjectFields () {
      if (this.extConnection.selectedObj) {
        this.showEFM = false
        Vue.axios.get('/settings/external_service_maps/object_fields?object_type=' + this.extConnection.selectedObj, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            this.extConnection.extFields = res.data.external_fields[0]
            this.extConnection.extFields.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0))
            this.extConnection.reqFields = res.data.external_fields[1]
            this.extConnection.allReqFields = JSON.parse(JSON.stringify(res.data.external_fields[1]))
            for (let extField of this.externalServiceMap.externalFieldMappings) {
              this.extConnection.reqFields = this.extConnection.reqFields.filter((req, index) => { return req.value !== extField.ext_field_api })
            }
            this.showEFM = true
          })
          .catch(error => {
            if (error.response.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    addFieldMapping () {
      var selectedTmpObj = this.templateDoc.tmpFields.filter((tmpField) => { return tmpField.value === this.externalServiceMap.selectedTmpField })[0]
      var selectedExtFieldObj = this.extConnection.extFields.filter((extField) => { return extField.value === this.externalServiceMap.selectedExtField })[0]
      let mappingData = new window.FormData()
      mappingData.append('template_doc_id', this.templateDoc.selectedTemplateDocId)
      mappingData.append('template_id', this.selectedTemplate)
      mappingData.append('revision_id', this.selectedTemplateVersion)
      mappingData.append('external_service_map_id', this.externalServiceMap.externalServiceMapId)
      let templateMappingId = selectedTmpObj && selectedTmpObj.value ? selectedTmpObj.value : null
      let templateMappingKey = selectedTmpObj && selectedTmpObj.text ? selectedTmpObj.text : null
      mappingData.append('template_mapping_id', templateMappingId)
      mappingData.append('template_mapping_key', templateMappingKey)
      mappingData.append('external_field_key', selectedExtFieldObj.value)
      mappingData.append('external_field_label', selectedExtFieldObj.text)
      mappingData.append('external_field_type', this.extConnection.selectedObj)
      mappingData.append('ef_datatype', selectedExtFieldObj.data_type)
      mappingData.append('default_value', this.defaultValue.trim())
      mappingData.append('section', this.selectedSection)
      mappingData.append('section_order', this.sectionsList.indexOf(this.selectedSection) + 1)
      Vue.axios.post('/settings/external_field_maps', mappingData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.status === 'SUCCESS') {
            this.externalServiceMap.externalFieldMappings.push({id: response.data.id, 'tmp_id': templateMappingId, 'tmp_key': templateMappingKey, 'ext_field_api': response.data.ext_field_api, 'ext_field_object': response.data.ext_field_object, default_value: this.defaultValue, section: this.selectedSection})
            this.extConnection.reqFields = this.extConnection.reqFields.filter((req, index) => { return req.value !== response.data.ext_field_api })
            this.externalServiceMap.selectedTmpField = ''
            this.externalServiceMap.selectedExtField = ''
            this.defaultValue = ''
            this.selectedSection = ''
            this.defaultValue = ''
            Vue.toasted.show(response.data.message)
          } else {
            Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    editExternalServiceMap (templateDocId) {
      Vue.axios.get('/settings/external_service_maps/' + templateDocId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          let result = response.data
          this.extServiceData.connection_type = result.external_service_maps ? result.external_service_maps.connection_type : 'Salesforce'
          this.extServiceData.integration_type = result.external_service_maps ? result.external_service_maps.integration_type : 'Default'
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
          this.availableTemplateVersions = [{text: 'Select Versions', value: null, disabled: true}].concat(result.versions)
          this.extServiceData.process_type = templateDocId === '-2' || templateDocId === -2 ? '-2' : '-5'
          if (templateDocId !== -2 && templateDocId !== -5) {
            this.extServiceData.process_type = 'Templates'
            this.showVersionsRow = true
            if (result.efm_template_id != null) {
              this.selectedTemplate = result.efm_template_id
            } else {
              this.selectedTemplate = result.templates[0]['value']
            }
            this.selectedTemplateVersion = result.versions[0]['value']
          }
          this.extConnection.extObjects = result.objects ? [].concat(result.objects) : []
          this.externalServiceMap.externalFieldMappings = result.external_field_mappings
          this.templateDoc.selectedTemplateDocId = templateDocId
          this.templateDoc.tmpFields = result.template_fields || []
          this.sectionsList = result.sections ? result.sections : []
          if (this.templateDoc.tmpFields) {
            this.templateDoc.tmpFields.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0))
          }
          if (result.external_service_maps) {
            this.extConnection.connection_type = result.external_service_maps.connection_type
            this.externalServiceMap.externalServiceMapId = result.external_service_maps.id
            this.showObjectRow = true
          } else {
            Vue.toasted.show('No service found for the latest version. Create it now', { icon: 'chain-broken', type: 'error' })
          }
          this.$refs.externalServiceModal.show()
        })
        .catch(error => {
          console.log(error)
          if (error.response && error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteExternalServiceMap () {
      Vue.axios.delete('/settings/external_service_maps/' + this.template_doc_id, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.deleted) {
            this.externalServiceMaps = this.externalServiceMaps.filter((esm, index) => { return esm.template_doc_id !== this.template_doc_id })
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteExternalFieldMap (fieldMapId, fieldExtApi) {
      Vue.axios.delete('/settings/external_field_maps/' + fieldMapId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.externalServiceMap.externalFieldMappings = this.externalServiceMap.externalFieldMappings.filter((efm, index) => { return efm.id !== fieldMapId })
          let presentExtMap = this.externalServiceMap.externalFieldMappings.filter((efm, index) => { return efm.ext_field_api === fieldExtApi })
          let presentReqMap = this.extConnection.allReqFields.filter((req, index) => { return req.value === fieldExtApi })
          if (presentReqMap.length && !presentExtMap.length) {
            this.extConnection.reqFields.push(presentReqMap[0])
          }
          Vue.toasted.show(this.$t('COMMON.MSG_FIELD_DEL'))
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadESM () {
      let esmId = this.externalServiceMap.externalServiceMapId
      Vue.axios.get('/settings/external_service_maps/' + esmId + '/download', { headers: {
        Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let data = res.data.efm_data
          let processedData = data
          let mimeType = 'application/json'
          let fileType = '.json'
          let blob = new window.Blob([JSON.stringify(processedData)], {
            type: mimeType
          })

          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = res.data.title + fileType
          document.body.appendChild(link)
          link.click()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .modelSelect /deep/ div.text{
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .delete-warning {
    font-size : 1rem;
    color: red;
  }
  .card {
    background: #ebeff3;
    border-radius: 10px;
  }
  .card-header {
    background: #f7f7f7;
  }
  .temp_mapping {
    background: #f8f9fa;
    padding: 0.5rem;
    margin: 0;
  }
  .external-service-modal {
    .row {
      margin-bottom: 7px;
    }
  }
  .download-efm {
    cursor: pointer;
  }

  .create-button{
    margin-top: 1.5rem;
  }
  .timeline-div {
    display: inline-block;
    width: 100%;
    overflow-y: auto;
    background-color: #f7f7f7;
    padding-top: 35px;
    margin: 0 auto;
    margin-bottom: 10px;
  }
  .timeline,
  .timeline-horizontal {
    list-style: none;
    padding: 20px;
    position: relative;
  }
  .timeline:before {
    top: 40px;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 5px;
    background-color: #5b648f;
    margin-left: -1.5px;
  }
  .timeline .timeline-item {
    margin-bottom: 20px;
    position: relative;
  }
  .timeline .timeline-item:before,
  .timeline .timeline-item:after {
    content: "";
    display: table;
  }
  .timeline .timeline-item:after {
    clear: both;
  }
  .timeline .timeline-item .timeline-badge {
    color: #fff;
    width: 60px;
    height: 60px;
    line-height: 52px;
    font-size: 18px;
    text-align: center;
    position: absolute;
    top: 18px;
    left: 50%;
    margin-left: -25px;
    background-color: #7c7c7c;
    border: 5px solid #5b648f;
    z-index: 100;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    cursor: move;
  }
  .timeline .timeline-item .timeline-badge.primary {
    background-color: #1f9eba;
  }
  .timeline .timeline-item .timeline-panel {
    position: relative;
    width: 20%;
    float: left;
    right: 10px;
    border: 1px solid white;
    background: #ffffff;
    border-radius: 10px;
    cursor: move;
    padding: 5px;
    max-width: 15em;
  }
  .timeline .timeline-item .timeline-panel:before {
    position: absolute;
    top: 26px;
    right: -16px;
    display: inline-block;
    border-top: 16px solid transparent;
    border-left: 16px solid #fff;
    border-right: 0 solid #fff;
    border-bottom: 16px solid transparent;
    content: " ";
  }
  .timeline .timeline-item .timeline-panel p {
      margin: 4px;
      text-align: center;
      font-weight: bolder;
  }
  .timeline-horizontal {
    list-style: none;
    position: relative;
    padding: 20px 0px 20px 0px;
    display: table;
    width: 100%;
  }
  .timeline-horizontal:before {
    height: 5px;
    top: auto;
    bottom: 26px;
    right: 0;
    width: 100%;
    margin-bottom: 20px;
  }
  .timeline-horizontal .timeline-item {
    display: table-cell;
    min-width: 200px;
    float: none !important;
    padding-left: 10px;
    padding-right: 10px;
    margin: 0 auto;
    vertical-align: bottom;
  }
  .timeline-horizontal .timeline-item .timeline-panel {
    top: auto;
    bottom: 36px;
    display: inline-block;
    float: none !important;
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    margin-bottom: 20px;
  }
  .timeline-horizontal .timeline-item .timeline-panel:before {
    top: auto;
    bottom: -16px;
    left: 76px !important;
    right: auto;
    border-right: 16px solid transparent !important;
    border-top: 16px solid #fff !important;
    border-bottom: 0 solid #fff !important;
    border-left: 16px solid transparent !important;
  }
  .timeline-horizontal .timeline-item:before,
  .timeline-horizontal .timeline-item:after {
    display: none;
  }
  .timeline-horizontal .timeline-item .timeline-badge {
    top: auto;
    bottom: 0px;
  }
  ul li.timeline-item{
   max-width: 2em;
  }
  .multi-card .card-body{
    padding: 1.25em 0 0 0;
  }
  .multi-card{
    margin-bottom:0;
  }
  .flex-container {
    display: flex;
    justify-content: center;
  }

  .timeline {
    margin: 0;
  }
  .button-style {
    font-size: 1rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    border-radius: 16px;
  }

  .button-style:nth-child(1) {
    margin-right: .5rem;
  }

  .button-style:nth-child(2) {
    margin-left: .5rem;
  }

  .panel-option:hover {
    cursor: pointer;
  }

  .panel-option {
    display: inline;
    position: absolute;
    right: 0;
    padding: 0 0.2rem;
  }

  .timeline-item .timeline-panel.role-panel {
    display: flex;
    justify-content: center;
  }
  .panel-option button {
    color: red;
    background-color: white;
  }
  .panel-option button ,.panel-option button:active:focus,
  .panel-option button:hover, .panel-option button:active,
  .panel-option .btn:not(:disabled):not(.disabled):active{
    color: inherit;
    background-color: inherit;
    border: none;
    box-shadow: none;
    padding: 5px 6px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/externalServiceMaps.vue